import { extractNationalNumber } from 'utils';

export const getSearchWorkerParams = (values: any) => ({
  firstName: values.firstName.trim(),
  lastName: values.lastName.trim(),
  email: values.email?.trim?.(),
  mobilePhoneNumber: extractNationalNumber(values.mobilePhoneNumber) ? values.mobilePhoneNumber : null,
  dateOfBirth: values.dateOfBirth
    ? typeof values.dateOfBirth === 'string'
      ? values.dateOfBirth
      : values.dateOfBirth.toISOString()
    : undefined,
  languageCode: values?.languageCode,
});
